const eanRegExp = /\d{14}/;

const isEAN = (string: string) => {
  return eanRegExp.test(string);
};

export default isEAN;
